import { IMonthlyWeightShipped } from "../../../api/MonthlyWeightShipped/MonthlyWeightShipped.types";
import NumberUtils from "../../../utils/number.utils";
import WidgetNivoBase from "../Widget.nivo.base";
import Tooltips from "../../common/Tooltips/Tooltips";
import "./styles.scss";

interface Props {
  data?: IMonthlyWeightShipped[]
}

interface TransformedData {
  date: string,
  [key: string]: number | string
}

function MonthlyWeightShipped({ data }: Props) {
  let pkgTypes: string[] = [];

  function getData() {
    if (data) {
      const newData: TransformedData[] = data
        .reduce((res: TransformedData[], item: IMonthlyWeightShipped) => {
          const { year, month, pkgType, totalWeight } = item;
          const date = `${month}/${year}`;
          const existingItem = res.find((item) => item.date === date);
          const weight = parseInt(totalWeight);

          if (!pkgTypes.includes(pkgType)) {
            pkgTypes.push(pkgType);
          }
          if (existingItem) {
            existingItem[pkgType] = (existingItem[pkgType] as number || 0) + weight;
          } else {
            const newItem: TransformedData = {
              date,
              [pkgType]: weight
            }

            res.push(newItem);
          }

          return res;
        }, []);
      return newData;
    }
  }

  return (
    <div className="monthly-weight">
      <WidgetNivoBase.Bar
        title={
          <Tooltips
            label={
              <>
                <span>Dates are in Actual Departure Date</span>
                <span>Package Type comes from <b>IESystem6_DB.dbo.oeUploadDetailSummary.PkgType</b></span>
                <span>Weight <b>IESystem6_DB.dbo.oeContainer.Weight</b></span>
              </>
            }
            children="Weight Shipped Per Month"
          />
        }
        data={getData()}
        keys={[...pkgTypes]}
        indexBy="date"
        marginBottom={70}
        axisLeftName="Weight (lbs)"
        axisBottomName=""
        axisBottomRotation={-45}
        groupMode={"grouped"}
        colors={{ scheme: "set2" }}
        formatValue={v => NumberUtils.toShortened(v, 2)}
        legendLabel={(el: any) => {
          if (el.id.length > 5)
            el.id = `${el.id.slice(0, 5)}.`
          return el.id
        }}
        legends={[
          {
            dataFrom: "keys",
            anchor: "bottom",
            direction: "row",
            itemWidth: 40,
            itemHeight: 12,
            itemDirection: "top-to-bottom",
            itemsSpacing: 8,
            symbolShape: "circle",
            symbolSize: 12,
            toggleSerie: true,
            translateX: 0,
            translateY: 50
          },
        ]}
        tooltip={({ id, value, color }) => (
          <div className="tooltip-panel" style={{ color }}>
            <div>{id ? `${id}: ` : ''}<strong>{NumberUtils.numberWithCommas(value)}</strong> lbs</div>
          </div>
        )}
      />
    </div>
  )
}

export default MonthlyWeightShipped;
